import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function WhatsappsFilter({ onFiltered, initialWhatsapps = [] }) {
  const [whatsapps, setWhatsapps] = useState([]);
  const [selecteds, setSelecteds] = useState(initialWhatsapps);

  useEffect(() => {
    let isMounted = true;
    
    async function fetchData() {
      if (isMounted) {
        await loadWhatsapps();
      }
    }
    fetchData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  const loadWhatsapps = async () => {
    try {
      const { data } = await api.get(`/whatsapp`);
      const whatsappList = data.map((w) => ({ id: w.id, name: w.name, channel: w.channel }));
      setWhatsapps(whatsappList);
    } catch (err) {
      console.error('Erro ao carregar whatsapps:', err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: "2px 10px" }}>
      <Autocomplete
        multiple
        size="medium"
        options={whatsapps || []}
        value={selecteds || []}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option?.name || ""}
        getOptionSelected={(option, value) => {
          return (
            option?.id === value?.id ||
            (option?.name && value?.name && option.name.toLowerCase() === value.name.toLowerCase())
          );
        }}
        ListboxProps={{
          style: { 
            maxHeight: '200px', // Altura para mostrar mais opções
            overflow: 'auto', // Permitir scroll se houver mais opções
            padding: '8px 0', // Padding interno para melhor espaçamento
            borderRadius: '4px', // Bordas arredondadas
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)' // Sombra sutil
          }
        }}
        renderTags={(value, getWhatsappProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: "#bfbfbf",
                textShadow: "1px 1px 1px #000",
                color: "white",
                height: "20px",
                fontSize: "11px"
              }}
              label={option?.name || ""}
              {...getWhatsappProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={i18n.t("tickets.search.filterConections")}
            size="medium"
            style={{ 
              marginBottom: "4px",
              minWidth: "250px",
              width: "100%"
            }}
            InputProps={{
              ...params.InputProps,
              style: {
                fontSize: "14px",
                padding: "8px 12px"
              }
            }}
          />
        )}
      />
    </Box>
  );
}
